var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__wrapper"},[_c('div',{staticClass:"footer__payments"},_vm._l((_vm.payments),function(payment,index){return _c('img',{key:index,attrs:{"src":payment,"alt":"#"}})}),0),_c('div',{staticClass:"footer__copyright"},[_vm._v(" ©LoveTime2016-"+_vm._s((new Date()).getFullYear())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }